export const SHIPMENTS_V2_GET_REQUEST = "SHIPMENTS_V2_GET_REQUEST";
export const SHIPMENTS_V2_GET_RECEIVE = "SHIPMENTS_V2_GET_RECEIVE";
export const SHIPMENTS_V2_GET_ERROR = "SHIPMENTS_V2_GET_ERROR";
